import { Tile, TileGroup, Typography } from '@one-thd/sui-atomic-components';
import React from 'react';
import { FeatureSwitches } from '../../../constants/feature-switches';
import { dateTileOptions } from '../../../constants/order-filter';
import { DateFilterSettings, DateSettings } from '../../../models/order-filter';
import { TDateSelectValues } from '../../../models/common';
import { OrderFilterInput } from './OrderFilterInput';

interface IOrderFilterDateSectionProps {
  tileSelectedDate: TDateSelectValues | null;
  customDateRange: DateSettings;
  setCustomDateRange: React.Dispatch<React.SetStateAction<DateSettings>>;
  setFilterSettings: React.Dispatch<React.SetStateAction<DateFilterSettings>>;
  onDateSelect: (
    _event: React.SyntheticEvent<Element, Event>,
    date: string,
  ) => void;
}

export const OrderFilterDateSection = ({
  tileSelectedDate,
  customDateRange,
  setCustomDateRange,
  setFilterSettings,
  onDateSelect,
}: IOrderFilterDateSectionProps) => {
  return (
    <div className="sui-relative sui-pt-[14px] sui-border-b-1 sui-border-solid sui-border-strong">
      <div className="sui-mb-[20px]">
        <Typography weight="bold" className="sui-mb-[4px]">
          Enter a custom range:
        </Typography>
        <div className="sui-flex sui-flex-col sui-gap-[12px] sui-w-full sui-items-center">
          <OrderFilterInput
            name="Start date"
            dateType="startDate"
            dateSettings={customDateRange}
            setDateSettings={setCustomDateRange}
            setFilterSettings={setFilterSettings}
          />
          <OrderFilterInput
            name="End date"
            dateType="endDate"
            dateSettings={customDateRange}
            setDateSettings={setCustomDateRange}
            setFilterSettings={setFilterSettings}
          />
        </div>
      </div>
      <div className="sui-mb-[12px]">
        <Typography weight="bold" className="sui-mb-[8px]">
          Select a range:
        </Typography>
        <TileGroup
          value={tileSelectedDate}
          onChange={onDateSelect}
          aria-label="date filter"
          orientation="vertical"
        >
          {(() => {
            const is25MonthDefault =
              FeatureSwitches.enableLSSCPS25MonthsDefault === true;
            const defaultOptionValue = is25MonthDefault
              ? 'last25Months'
              : 'last6Months';

            return dateTileOptions.map((option) => {
              if (is25MonthDefault && option.value === 'last6Months') {
                return null;
              }

              if (!is25MonthDefault && option.value === 'last25Months') {
                return null;
              }

              return (
                <Tile
                  key={option.value}
                  value={option.value}
                  aria-label={option.label}
                >
                  <Typography className="sui-mr-auto">
                    {option.label}
                    {option.value === defaultOptionValue ? ' (Default)' : ''}
                  </Typography>
                </Tile>
              );
            });
          })()}
        </TileGroup>
      </div>
    </div>
  );
};
